import SButton from './s-button'
import SInput from "./s-input";
import SToggle from "./s-toggle";
import SLabel from "./s-label";
import SError from "./s-error";


export {
  SButton,
  SInput,
  SToggle,
  SLabel,
  SError,
}
